module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Comment1_16"],"path":[{"$":{"d":"M14,3v7H10.32L8,11.78V10H2V3H14m2-2H0V12H6v3.83L11,12h5V1Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Comment1_16.svg
// module id = 8Dar
// module chunks = 1